import {IssueDraftIcon} from '@primer/octicons-react'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {ConvertedFromDraftEventNode} from './issue-viewer-page-query-types'
import {TimelineRow} from './row/TimelineRow'

export type ConvertedFromDraftEventFragment = Pick<ConvertedFromDraftEventNode, 'actor' | 'createdAt' | 'databaseId'>

type ConvertedFromDraftEventProps = {
  queryRef: ConvertedFromDraftEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
}

export function ConvertedFromDraftEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
}: ConvertedFromDraftEventProps): React.ReactElement {
  const {actor, createdAt, databaseId} = queryRef

  const highlighted = String(databaseId) === highlightedEventId

  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      onLinkClick={onLinkClick}
      leadingIcon={IssueDraftIcon}
    >
      <TimelineRow.Main>{`${LABELS.timeline.convertedFromDraftIssue} `}</TimelineRow.Main>
    </TimelineRow>
  )
}
